import { logger } from '@fe/core';
import { FlightLayerFacade } from '@fe/flight-layer';
import { FeMap } from '@fe/maplibre-extensions';
import { GDFProductType } from '../gdf/type';
import { GeoJsonLayer } from '../layers/geojson/geojson-layer';
import { LightningLayer } from '../layers/lightning/lightning-layer';
import { RasterSingleCustomLayer } from '../layers/raster/raster-single-custom-layer';
import { SigWxLayer } from '../layers/sig-wx/sig-wx-layer';
import { CustomPolygonLayer } from '../layers/vector/custom-polygon-layer';
import { IataTurbulenceLayer } from '../layers/vector/iata-turbulence-layer';
import { WeatherLayerBase } from '../layers/weather-layer-base';
import { WindsCompositeLayer } from '../layers/winds/winds-composite-layer';
import { WeatherSettings } from '../settings/settings';
import { isCustomPolygonLayer, isLightningCustom, isSigWx, isWindsProduct } from '../utils/utils';
import { Dispatcher } from '../worker/dispatcher';
import { WeatherStoreProductInfo } from '../worker/store/weather-store';

export function layerFactory(
    dispatcher: Dispatcher,
    workspaceId: number,
    product: WeatherStoreProductInfo,
    map: FeMap,
    topSlot: string,
    settings: WeatherSettings,
    flightLayerFacade: FlightLayerFacade | null
): WeatherLayerBase | null {
    const info = product;
    try {
        if (info.frames[0].header.productType === GDFProductType.geolay) {
            return new RasterSingleCustomLayer(map, workspaceId, dispatcher, product.id, topSlot, settings);
        } else if (info.frames[0].header.productType === GDFProductType.popup) {
            return new RasterSingleCustomLayer(map, workspaceId, dispatcher, product.id, topSlot, settings);
        } else {
            if (isWindsProduct(product.id)) {
                return new WindsCompositeLayer(map, workspaceId, dispatcher, product.id, topSlot, settings, flightLayerFacade);
            } else if (product.id === 0x6049) {
                return new IataTurbulenceLayer(map, workspaceId, dispatcher, product.id, topSlot, settings);
            } else if (isLightningCustom(product.id)) {
                return new LightningLayer(map, workspaceId, dispatcher, product.id, topSlot, settings);
            } else {
                if (isCustomPolygonLayer(product.id)) {
                    return new CustomPolygonLayer(map, workspaceId, dispatcher, product.id, topSlot, settings);
                }

                if (isSigWx(product.id)) {
                    return new SigWxLayer(map, workspaceId, dispatcher, product.id, topSlot, settings);
                }

                return new GeoJsonLayer(map, workspaceId, dispatcher, product.id, topSlot, settings);
            }
        }
    } catch (e) {
        logger.error(`Error creating layer for product ${JSON.stringify(product)}:`, e);
        throw e;
    }
}
